var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.state.token)?_c('page-header'):_vm._e(),_c('main',[_c('router-view'),_c('accept-terms')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }